// extracted by mini-css-extract-plugin
module.exports =  {"package-description":"OjAbcOU","packageDescription":"OjAbcOU"};